import {
  endpoint,
  regex,
} from "../../../../views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  getDropdownIdsFromSelectArray,
} from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import React from 'react';

export const getBulkSearchFormFields = (dropdownData) => {
  const {
    businessAres,
    courseIdDropdown,
    courseIdDropdownLoading,
    term,
    academicCareer,
    stream,
    resetCourseId,
  } = dropdownData;
  return [
    {
      label: "Business Area",
      type: "select",
      items: businessAres,
      formKey: "businessArea",
      onChange: resetCourseId,
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Term",
      type: "select",
      items: term,
      formKey: "term",
      onChange: resetCourseId,
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Course Id",
      type: "select",
      items: courseIdDropdown,
      formKey: "courseId",
      onChange: () => {},
      loading: courseIdDropdownLoading,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Academic Group",
      type: "select",
      items: stream,
      formKey: "academicGroup",
      onChange: () => {},
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Career",
      type: "select",
      items: academicCareer,
      formKey: "academicCareer",
      onChange: () => {},
      loading: false,
      isMulti: false,
      placeholder: "Select",
    },

    {
      label: "Registration Date",
      type: "date",
      items: [],
      formKey: "registrationStartDate",
      onChange: () => {},
      loading: false,
      placeholder: "From",
      minDate: "",
      maxDate: "",
    },

    {
      label: <div style={{marginTop : '14px'}}></div>,
      type: "date",
      items: [],
      formKey: "registrationEndDate",
      onChange: () => {},
      loading: false,
      placeholder: "To",
      minDate: "",
      maxDate: "",
    },
  ];
};

export const singleSearchParams = [
  {
    label: "PSID",
    field: "psid",
    placeholder: "Enter 11 digit PSID",
    regEx: /^[0-9]{0,11}$/,
  },
  {
    label: "Application Id",
    field: "applicationId",
    placeholder: "Enter 8 digit Application Id",
    regEx: /^[0-9]{0,8}$/,
  },
];

const getAcademicCarrier = (academicCarrierList) => {
  if (!Array.isArray(academicCarrierList) || !academicCarrierList.length)
    return [];

  return [academicCarrierList[0].label];
};

const getFilterFormReqObj = (filterForm, allActiveBu) => {
  const {
    businessArea,
    term,
    courseId,
    academicGroup,
    academicCareer,
    registrationStartDate,
    registrationEndDate,
    psid,
    applicationId,
    studentName,
  } = filterForm;
  const filterBUs = !!businessArea ? [businessArea] : allActiveBu;
  const filterTerms = term ? [term] : [];
  const filterCourseIds = courseId ? [courseId] : [];
  const academicGroupList = academicGroup ? [academicGroup] : [];
  const academicCarrierList = academicCareer ? [academicCareer] : [];

  return {
    psid,
    applicationId,
    studentName,
    businessArea: getDropdownIdsFromSelectArray(filterBUs),
    term: getDropdownIdsFromSelectArray(filterTerms),
    courseId: getDropdownIdsFromSelectArray(filterCourseIds),
    academicGroupValue: getDropdownIdsFromSelectArray(academicGroupList),
    academicCareerValue: getAcademicCarrier(academicCarrierList),
    startDate: registrationStartDate,
    endDate: registrationEndDate,
  };
};

const validateForm = (form) => {
  const { psid, applicationId } = form;
  if (psid && psid?.length != 11) {
    failureToast("PSID must be 11 digit long");
    return false;
  }

  if (applicationId && applicationId?.length != 8) {
    failureToast("Application Id must be 8 digit long");
    return false;
  }

  return true;
};

export const searchStudents = (filterForm, offset, dropdowns, limit = 50) => {
  if (!validateForm(filterForm)) return;
  const reqObj = getFilterFormReqObj(filterForm, dropdowns?.businessAres);
  return fetchAllPostPromisedData(
    `${endpoint.allocateStudents.searchStudentApplications}?offset=${offset}&limit=${limit}`,
    reqObj
  );
};
